var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0991 19.0835L7 12.9844V14.2304C7 14.5606 7.13083 14.8783 7.36757 15.1088L12.2207 19.9619C12.7066 20.4479 13.4978 20.4479 13.9838 19.9619L17.8526 16.0931C18.3385 15.6072 18.3385 14.816 17.8526 14.33L13.0991 19.0835Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2207 16.8464C12.7066 17.3323 13.4978 17.3323 13.9838 16.8464L17.8526 12.9776C18.3385 12.4916 18.3385 11.7004 17.8526 11.2145L12.9994 6.36134C12.7628 6.13039 12.4455 6.00078 12.1148 6H8.24599C7.5607 6 7 6.5607 7 7.24599V11.1148C7 11.445 7.13083 11.7627 7.36757 11.9932L12.2207 16.8464ZM9.64773 7.86899C9.85427 7.86899 10.0523 7.95103 10.1984 8.09708C10.3444 8.24312 10.4265 8.4412 10.4265 8.64773C10.4265 8.85427 10.3444 9.05234 10.1984 9.19839C10.0523 9.34443 9.85427 9.42648 9.64773 9.42648C9.4412 9.42648 9.24312 9.34443 9.09708 9.19839C8.95103 9.05234 8.86899 8.85427 8.86899 8.64773C8.86899 8.4412 8.95103 8.24312 9.09708 8.09708C9.24312 7.95103 9.4412 7.86899 9.64773 7.86899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoFilledIcon);
export default __webpack_public_path__ + "static/media/promo-filled-icon.58480e333b45e7ea1840d978b4c6e262.svg";
export { ForwardRef as ReactComponent };